import React, { useState, useEffect } from "react";
import ParagraphTag from "../../reusebale/Paragraph";
import ImageTag from "../../reusebale/imageTag";
import db from "../../../db/index.json";
import ReactPaginate from "react-paginate";
import NoData from "../../reusebale/noData";
import LeaseTableLoader from "../../skeleton-loader/lease-table";
import {
  Plus,
  ArrowUpDown,
  ArrowDownUp,
  SquareCheck,
  SquareX,
  Star,
} from "lucide-react";
import BaseUrl from "../../../constants/BaseUrl";
import { useSelector } from "react-redux";
const SupportStaff = ({ createSupport, detailStaff }) => {
  const { support } = db;
  const [AllAllRequest, setAllResuests] = useState([
    {
      id: 1,
      staffId: "TID-000199581",
      staffName: "Lorri Warf",
      active: "active",
      time: "13 Minutes",
      type: "Technical",
    },
    {
      id: 2,
      staffId: "TID-000199581",
      staffName: "Lorri Warf",
      active: "deactive",
      time: "13 Minutes",
      type: "Technical",
    },
    {
      id: 1,
      staffId: "TID-000199581",
      staffName: "Lorri Warf",
      active: "active",
      time: "13 Minutes",
      type: "Technical",
    },
    {
      id: 2,
      staffId: "TID-000199581",
      staffName: "Lorri Warf",
      active: "deactive",
      time: "13 Minutes",
      type: "Technical",
    },
    {
      id: 1,
      staffId: "TID-000199581",
      staffName: "Lorri Warf",
      active: "active",
      time: "13 Minutes",
      type: "Technical",
    },
    {
      id: 2,
      staffId: "TID-000199581",
      staffName: "Lorri Warf",
      active: "deactive",
      time: "13 Minutes",
      type: "Technical",
    },
    {
      id: 1,
      staffId: "TID-000199581",
      staffName: "Lorri Warf",
      active: "active",
      time: "13 Minutes",
      type: "Technical",
    },
    {
      id: 2,
      staffId: "TID-000199581",
      staffName: "Lorri Warf",
      active: "deactive",
      time: "13 Minutes",
      type: "Technical",
    },
    {
      id: 1,
      staffId: "TID-000199581",
      staffName: "Lorri Warf",
      active: "active",
      time: "13 Minutes",
      type: "Technical",
    },
    {
      id: 2,
      staffId: "TID-000199581",
      staffName: "Lorri Warf",
      active: "deactive",
      time: "13 Minutes",
      type: "Technical",
    },
    {
      id: 1,
      staffId: "TID-000199581",
      staffName: "Lorri Warf",
      active: "active",
      time: "13 Minutes",
      type: "Technical",
    },
    {
      id: 2,
      staffId: "TID-000199581",
      staffName: "Lorri Warf",
      active: "deactive",
      time: "13 Minutes",
      type: "Technical",
    },
  ]);

  const [data, allData] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [updatingStatus, setUpdatingStatus] = useState({});
  const { loginSuccess } = useSelector((state) => state.auth);

  const GetAllSupportStaff = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/support/getAvailableSupportStaff?getRating=true`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success" || result.status === "success") {
          allData(result?.data);
        }
      })
      .catch((error) => console.error(error));
  };

  const UpdateSupportStatus = (id, status) => {
    setUpdatingStatus((prev) => ({ ...prev, [id]: true }));

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: JSON.stringify({ allowLogin: status }),
      redirect: "follow",
    };
    fetch(`${BaseUrl}api/support/updateSupportStaff/${id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success" || result.status === "success") {
          GetAllSupportStaff();
        } else {
          console.error("Error updating support status:", result.message);
        }
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => {
        setUpdatingStatus((prev) => ({ ...prev, [id]: false }));
      });
  };

  useEffect(() => {
    GetAllSupportStaff();
  }, []);

  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;
  const paginatedData = AllAllRequest.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  const handlePageClick = (selectedPage, id) => {
    setCurrentPage(selectedPage.selected, id);
  };

  // State for sorting
  const [sortConfig, setSortConfig] = useState({
    key: "lease",
    direction: "asc",
  });
  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
    const sortedData = [...AllAllRequest].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === "asc" ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === "asc" ? 1 : -1;
      }
      return 0;
    });
    setAllResuests(sortedData);
  };

  function GetSelectedDays(schedule) {
    return schedule
      .filter((item) => item.isSelected) // Filter selected days
      .map((item) => item.day) // Extract the 'day' value
      .join(", "); // Combine into a single string
  }

  return (
    <div className=" h-full pt-5 bg-white">
      <div className="w-full h-[98%]">
        <div className="w-[95%] mx-auto h-full">
          <div className="flex items-center h-[12%]">
            <div className="w-[60%] 2xl:w-[70%]">
              <ParagraphTag
                content={support.tableHead}
                classes="text-darkColor font-popinsSemiBold text-base pl-2"
              />
            </div>
            <div className="w-[40%] 2xl:w-[30%] flex justify-end">
              <button
                className="bg-themeColor flex justify-center items-center py-2 font-popinsMedium text-white text-xs rounded-lg w-[50%]"
                onClick={createSupport}
              >
                <Plus size={18} color="#ffff" />
                <span className="pl-2">{support.btnName}</span>
              </button>
            </div>
          </div>
          <div className="overflow-x-scroll w-full h-[88%] panelScroll pt-2">
            <table className="w-full ">
              <thead className="sticky top-0 bg-white">
                <tr className="border-b border-black/20">
                  <th className="w-[25%] text-left pb-2">
                    <span className="flex">
                      <ParagraphTag
                        content={support.thead1}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {sortConfig.key === "lease" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("lease")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("lease")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("lease")}
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[20%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={support.thead2}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {sortConfig.key === "status" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("status")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("status")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("status")}
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[10%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={support.thead3}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {sortConfig.key === "propertyInfo?.propertyName" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() =>
                              requestSort("propertyInfo?.propertyName")
                            }
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() =>
                              requestSort("propertyInfo?.propertyName")
                            }
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() =>
                            requestSort("propertyInfo?.propertyName")
                          }
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[20%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={support.thead7}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pl-2"
                      />
                      {sortConfig.key === "date" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("date")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("date")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("date")}
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[13%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={support.thead5}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pl-2"
                      />
                      {sortConfig.key === "dueDate" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("dueDate")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("dueDate")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("dueDate")}
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[12%] text-right pr-4 pb-2">
                    <ParagraphTag
                      content={support.thead6}
                      classes="text-darkColor/40 font-popinsSemiBold text-xs"
                    />
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((item) => (
                  <tr
                    key={item?._id}
                    className="hover:bg-gray-100 rounded-md cursor-pointer"
                  >
                    <td
                      className="py-2 cursor-pointer"
                      onClick={() => {
                        detailStaff(item);
                      }}
                    >
                      <div className="flex items-center justify-between">
                        <div className="w-[18%] rounded-full">
                          <ImageTag
                            path="/assets/daashboard/setting-icon.png"
                            classes="w-full"
                            altText="logo"
                          />
                        </div>
                        <div className="w-[78%] cursor-pointer">
                          <ParagraphTag
                            content={`STAFF-${item?._id?.slice(0, 10)}`}
                            classes="text-darkColor/50 font-popinsMedium text-xs"
                          />
                          <ParagraphTag
                            content={`${item?.firstName} ${item?.lastName}`}
                            classes="text-darkColor font-popinsSemiBold text-sm"
                          />
                        </div>
                      </div>
                    </td>
                    <td className="py-2">
                      <div className="flex justify-center">
                        {[...Array(5)].map((_, index) => (
                          <Star
                            key={index}
                            size={15}
                            className={`${
                              index < Math.round(item?.averageRating || 0)
                                ? "fill-[#FCCA01] stroke-[#FCCA01]"
                                : "stroke-[#B3B3B3]"
                            } mr-1`}
                          />
                        ))}
                      </div>
                    </td>
                    <td className="py-2 font-popinsMedium text-darkColor text-sm">
                      <div className="flex justify-center items-center">
                        <span>
                          {item?.allowLogin ? (
                            <SquareCheck color="green" size={20} />
                          ) : (
                            <SquareX color={"#FF814E"} size={20} />
                          )}
                        </span>
                      </div>
                    </td>
                    <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                      {GetSelectedDays(item?.shiftDays)}
                    </td>
                    <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                      {item.type}
                    </td>
                    <td className="pt-5 2xl:pt-4 px-4 flex justify-end items-center h-full pr-8">
                      <label className="inline-flex items-center cursor-pointer relative pl-3">
                        <input
                          checked={item?.allowLogin}
                          type="checkbox"
                          className="sr-only peer"
                          onChange={(e) =>
                            UpdateSupportStatus(item._id, e.target.checked)
                          }
                          disabled={updatingStatus[item._id]}
                        />
                        <div
                          className={`relative w-11 h-6 bg-[#E43B3B38] peer-focus:outline-none rounded-full peer dark:bg-[#E43B3B38] peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-[#0381CA] after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-[#0381CA] after:border-[#0381CA] after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-[#0381CA] peer-checked:bg-[#E43B3B38] ${
                            updatingStatus[item._id]
                              ? "opacity-50 cursor-not-allowed"
                              : ""
                          }`}
                        ></div>
                      </label>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {Loading && <LeaseTableLoader />}
            {data.length === 0 && !Loading && (
              <div className="w-full mt-5">
                <NoData />
              </div>
            )}
          </div>
        </div>
      </div>
      {/* <div className="flex justify-center items-center h-[13%]">
                <ReactPaginate
                  previousLabel="Previous"
                  nextLabel="Next"
                  breakLabel="..."
                  // pageCount={Math.ceil(data.length / itemsPerPage)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName="flex space-x-2 items-center"
                  pageClassName="px-3 py-1 border rounded-md text-sm font-popinsMedium cursor-pointer"
                  previousClassName="px-3 py-1 border rounded-l-md text-sm cursor-pointer font-popinsMedium"
                  nextClassName="px-3 py-1 border rounded-r-md text-sm font-popinsMedium cursor-pointer font-popinsMedium"
                  disabledClassName="opacity-50 !cursor-not-allowed"
                  activeClassName="bg-themeColor text-white"
                  breakClassName="px-3 py-1 text-sm font-popinsMedium"
                />
                </div> */}
    </div>
  );
};

export default SupportStaff;
